import { Navigate } from 'react-router';

import { ROUTES } from '@/config/routes';
import { useWorkspaceNav } from '@/layouts/workspace/useWorkspaceNav';
import { useUiModeStore } from '@/stores/uiMode';

import { useMobileTabs } from '../config/mobileTabs';
import { isMobileDevice } from '../lib/device';

/**
 * 워크스페이스 첫 진입 분기(specs/037 FR-004·R-002) — `/workspace` 에서만 동작한다(로그인 직후 기본 복귀지도 여기).
 * 모바일 기기 + 화면 선택 auto(탭 세션 기준 — 새 방문은 항상 auto) → 허용된 첫 모바일 탭, 그 밖은 허용된 첫 PC 메뉴.
 * 지도사는 공고 찾기(specs/031 FR-006)·공고 검색(#204), 기업 회원은 홈이 된다 — 축 분기 없이 메뉴 순서·기능 목록으로 정한다(specs/065 FR-008).
 * 특정 화면 주소로 직접 들어온 경우(딥링크)는 그 화면을 유지한다 — 이 컴포넌트를 거치지 않는다.
 */
export function WorkspaceEntryRedirect() {
  const uiMode = useUiModeStore((s) => s.uiMode);
  const firstMenu = useWorkspaceNav()[0]?.to;
  const firstTab = useMobileTabs()[0]?.to;
  const mobile = uiMode === 'auto' && isMobileDevice();
  const to = mobile
    ? (firstTab ?? ROUTES.workspace.mobile.search)
    : (firstMenu ?? ROUTES.workspace.announcements);
  return <Navigate to={to} replace />;
}
